// EasySell writes its button colours as inline !important styles, which no stylesheet can
// override. Re-apply the theme's primary button look on top of them whenever EasySell
// renders or re-styles its buttons.
(function () {
  const SELECTORS = ['#es-popup-button', '#es-form-button'];

  function themeColor(name, fallback) {
    const source = document.querySelector('.product__info-container') || document.body;
    const value = getComputedStyle(source).getPropertyValue(name).trim();
    return value ? `rgb(${value})` : fallback;
  }

  function styleButton(button) {
    // Skip if nothing has touched the style since we last applied ours (avoids observer loops).
    if (button.dataset.codStyled && button.dataset.codStyled === button.style.cssText) return;
    const styles = {
      'background': themeColor('--color-button', '#2a1d27'),
      'background-color': themeColor('--color-button', '#2a1d27'),
      'color': themeColor('--color-button-text', '#ffffff'),
      'border-radius': '4rem',
      'border-width': '0px',
      'font-family': 'var(--font-body-family)',
      'font-size': '1.5rem',
      'font-weight': '600',
      'letter-spacing': '0',
      'box-shadow': 'none',
    };
    Object.entries(styles).forEach(([property, value]) => button.style.setProperty(property, value, 'important'));
    button.dataset.codStyled = button.style.cssText;
  }

  function apply() {
    document.querySelectorAll(SELECTORS.join(',')).forEach(styleButton);
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  });

  function start() {
    apply();
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
